<h1>Nieuws</h1>
<article *ngFor="let item of nieuws$ | async as nieuws">
<h2>{{ item.text }}</h2>
<p [innerHTML]="item.bericht | markdown"></p>
</article>
